import { ROUTER_MANAGE_EDIT } from './constants'
import { 
    getAppDetailApi,
    getAppRouterListApi,
    updateAppItemApi,
    updateRouterApi,
    getJurisdictionDetailApi,
    getGroupListApi,
    editGroupJurisdictionApi,
    getGroupCustomersApi,
    dragNodeApi } from './service'
const model = {
    name: ROUTER_MANAGE_EDIT,
    namespaced: true,
    state: {
      jurisdictionItemSelected: null,
      jurisdictionGroups:[],
      jurisdictionPersons: [],
      appList:[],
      appDetail:{},
      tree: [],
      groupList:[],
      groupDict:{},
      loading: { 
        appLoading: false,
        getListLoading: false,
        getAppDetailLoading:false,
        routerSubmitLoading:false,
        jurisdictionLoading:false,
        editJurisdictionLoading:false,
        dragNodeLoading:false
      },
    },
    mutations: {
      setStateLevel0 (state,{key,value}) {
        state[key] = value
      },
      setLoading (state,{key,value}) {
        state.loading[key] = value
      },
      initData (state) {
        state.jurisdictionItemSelected = null
        state.jurisdictionGroups=[]
        state.jurisdictionPersons=[]
      }
    },
    actions: {
        // 获取app详情
        async getAppDetail ({ commit },params) {
          let paramsCLone = params
          if(params.payload) {
            paramsCLone = params.payload
          }
          // commit('setStateLevel0',{ key:'tree', value: [ ]})
          // commit('setStateLevel0',{ key:'appDetail', value: {} })
          commit('setLoading',{ key:'getAppDetailLoading', value:true })
          const { app } = await getAppDetailApi(paramsCLone,() => {
            commit('setLoading',{ key:'getAppDetailLoading', value:false })
           })
           commit('setStateLevel0',{ key:'tree', value: [ app ]})
           commit('setStateLevel0',{ key:'appDetail', value: app })
        },
        // 获取app列表
        async getAppRouterList ({ commit },params) {
          commit('setLoading',{ key:'getListLoading', value:true })
          const { list } = await getAppRouterListApi(params,() => {
            commit('setLoading',{ key:'getListLoading', value:false })
          })
          commit('setStateLevel0',{ key:'appList', value:list})
        },
        // 更新app item
        async setAppItem ({ commit,dispatch },{params,callBack}) {
          commit('setLoading',{ key:'appLoading', value:true })
          await updateAppItemApi(params,() => {
            commit('setLoading',{ key:'appLoading', value:false })
          })
          if(callBack) {
            callBack()
          }
          dispatch({type:'getAppRouterList'})
        },
        // 更新router updateRouterApi
        async updateRouter ({ commit,state,dispatch },{params,callBack}) {
          commit('setLoading',{ key:'routerSubmitLoading', value:true })
          await updateRouterApi({...params,route_app_id:state.appDetail.id},() => {
            commit('setLoading',{ key:'routerSubmitLoading', value:false })
          })
          callBack()
          dispatch({type:'getAppDetail',payload:{id:state.appDetail.id}})
        },
        async getJurisdictionDetail ({ commit,state },{ params }) {
          commit('setLoading',{ key:'jurisdictionLoading', value:true })
          commit('setStateLevel0',{key:'jurisdictionItemSelected',value:null})
         const { item } = await getJurisdictionDetailApi({id:params.id},() => {
          commit('setLoading',{ key:'jurisdictionLoading', value:false })
         })
         item.groups = item.groups||[]
         item.groups.forEach(child => {// hack 更新groupDict让每一个条目都有customers
          state.groupDict[child.id] = child
         });
         commit('setStateLevel0',{key:'jurisdictionItemSelected',value:item})
         commit('setStateLevel0',{key:'jurisdictionGroups',value:item.groups||[]})
         commit('setStateLevel0',{key:'jurisdictionPersons',value:item.customers||[]})
        },
        async getGroupList ({ commit }) {
          const { groups } = await getGroupListApi({})
          const groupClone = groups || []
          // groupDict
          commit('setStateLevel0',{key:'groupDict',value:groupClone.reduce((total,item) => {
            total[item.id] = {...item,customers:undefined}
            return total
          },{})})
          commit('setStateLevel0',{key:'groupList',value:groupClone})
        },
        async editGroupJurisdiction ({ commit },{
          id,
          add_group_ids,
          del_group_ids,
          add_customer_ids=[],
          del_customer_ids=[],
          callBack
        }) {
          const paramsClone = {id,add_group_ids,del_group_ids,add_customer_ids,del_customer_ids}
          commit('setLoading',{ key:'editJurisdictionLoading', value:true })
          const { item } = await editGroupJurisdictionApi(paramsClone,() => {
            commit('setLoading',{ key:'editJurisdictionLoading', value:false })
          })
          commit('setStateLevel0',{key:'jurisdictionItemSelected',value:item})
          commit('setStateLevel0',{key:'jurisdictionGroups',value:item.groups||[]})
          commit('setStateLevel0',{key:'jurisdictionPersons',value:item.customers||[]})
          if(callBack) {
            callBack()
          }
        },
        async getGroupCustomers (noThing,params) {
          const { group } = await getGroupCustomersApi({id:params.id})
          const { customers = [] } = group || {}
          params.customers = customers // hack
        },
        async dragNode ({ commit,dispatch,state },params) {
          const {callBack,...other} = params
          commit('setLoading',{ key:'dragNodeLoading', value:true })
          const { item={} } = await dragNodeApi(other,() => {
            commit('setLoading',{ key:'dragNodeLoading', value:false })
          })
          if(callBack) {
            callBack(item.name)
          }
          dispatch({type:'getAppDetail',payload:{id:state.appDetail.id}})
        }
    }
  };
  
  export default model;
  